import Link from 'next/link';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

const FlexLinkComponent = styled(Link)`
  flex: 1;
  display: flex;
  text-decoration: none;
`;

const InertFlexLinkComponent = styled.div`
  flex: 1;
  display: flex;
`;

const InlineLinkComponent = styled(Link)`
  text-decoration: none;
`;

interface LinkProps {
  url: string;
  className?: string;
  onClickCallback?: () => void;
  children?: ReactNode;
}

type CtaBlockLinkProps = LinkProps & {
  inline?: boolean;
};

const FlexLink: FC<LinkProps> = ({
  url,
  children,
  className,
  onClickCallback,
}) => {
  if (url) {
    return (
      <FlexLinkComponent
        data-type="CtaBlockLink"
        href={url}
        className={className}
        onClick={onClickCallback}
      >
        {children}
      </FlexLinkComponent>
    );
  }

  return (
    <InertFlexLinkComponent data-type="CtaBlockLink" className={className}>
      {children}
    </InertFlexLinkComponent>
  );
};

const InlineLink: FC<LinkProps> = ({
  url,
  children,
  className,
  onClickCallback,
}) => {
  if (url) {
    return (
      <InlineLinkComponent
        data-type="CtaBlockLink"
        href={url}
        className={className}
        onClick={onClickCallback}
      >
        {children}
      </InlineLinkComponent>
    );
  }

  return <>{children}</>;
};

const CtaBlockLink: FC<CtaBlockLinkProps> = ({
  inline = false,
  url,
  children,
  className,
  onClickCallback,
}) => {
  const LinkComponent = inline ? InlineLink : FlexLink;

  return (
    <LinkComponent
      url={url}
      className={className}
      onClickCallback={onClickCallback}
    >
      {children}
    </LinkComponent>
  );
};

export default CtaBlockLink;
